// utils/bdNumber.ts

/** Group an integer digit-string BD-style: 12,34,56,789 (3 from the right, then 2s) */
const groupBD = (digits: string): string => {
    if (digits.length <= 3) return digits;
    const last3 = digits.slice(-3);
    const head  = digits.slice(0, -3);
    return head.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3;
  };
  
  /**
   * Bangladeshi (lakh/crore) number format. Dot decimal separator, comma grouping.
   * @param decimals fixed fraction digits (default 2). Pass 0 for whole numbers.
   */
  export const fmtBD = (
    v: number | string | null | undefined,
    decimals = 2,
  ): string => {
    const n = Number(v ?? 0);
    if (!Number.isFinite(n)) return decimals > 0 ? (0).toFixed(decimals) : '0';
    const neg = n < 0;
    const [intPart, fracPart] = Math.abs(n).toFixed(decimals).split('.');
    const out = fracPart ? `${groupBD(intPart)}.${fracPart}` : groupBD(intPart);
    return neg ? `-${out}` : out;
  };